module.exports = __webpack_public_path__ + "img/2-full-lg.3063e3a8.jpg";